// MessagesMessageId.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import MongoObjectIdMatcher from '../component/MongoObjectIdMatcher.jsx';
import Redirect from '../container/Redirect.js';
import { EMPTY_ARRAY } from '../resource/defaults.js';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const MessagesMessageIdRoute = () => {
  const { meta = EMPTY_ARRAY } = useLoaderData();

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <MongoObjectIdMatcher paramKeys={['messageId']}>
        <Redirect to="/message/:messageId" />
      </MongoObjectIdMatcher>
    </>
  );
};

export default MessagesMessageIdRoute;
